import { index, jsonb, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export const notifications = pgTable("notifications", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    userId: uuid("user_id").notNull(),
    source: text("source").notNull().$type(),
    type: text("type").notNull().$type(),
    title: text("title").notNull(),
    body: text("body"),
    metadata: jsonb("metadata").notNull().default({}),
    actionIds: jsonb("action_ids").$type().default([]),
    dismissedAt: timestamp("dismissed_at", { withTimezone: true }),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
}, table => ({
    companyUserIdx: index("notifications_company_user").on(table.companyId, table.userId),
    createdIdx: index("notifications_created").on(table.companyId, table.userId, table.createdAt),
    sourceIdx: index("notifications_source").on(table.companyId, table.source),
}));
